module.exports = __webpack_public_path__ + "img/question18c1.916fea1d.png";